import React from 'react';
import { Card } from 'semantic-ui-react';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import { MAX_RATING_VALUE } from '../../Review.constants';
import './RatingLabel.css';
var defaultProps = {};
export default function RatingLabel(_ref) {
  var rating = _ref.rating;
  if (_isNil(rating)) {
    return null;
  }
  var ratingNumber = +rating;
  if (!_isNumber(ratingNumber)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Card.Description, {
    className: "rating-label"
  }, ratingNumber, " / ", MAX_RATING_VALUE, " Stars");
}
RatingLabel.defaultProps = defaultProps;